export class PoOrder {
  collection_id: string;
  collection_name: string;
  color_id: string;
  color_name: string;
  design_name: string;
  mystic_color_name: string;
  mystic_design_name: string;
  quantity: number;
  unit_price: number;
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/purchasing/pos/po-orders.ts